'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../../../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  clientInfo: {
    client_type: 'dedicated'
  },
  config: {
    id: '',
    theme: 'theme-background-color-pink',
    backgroundPosition: 'center',
    backgroundImage: {
      url: ''
    }
  },
  content: {
    image: {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/gb/en/online-sellers-solutions/Icon_4.png'
    },
    headline: {
      text: '50 characters (2 lines) maximum.'
    },
    paragraph: {
      text: '150 characters (3 lines) maximum'
    },
    toggleSection: _.ToggleSection.defaultProps,
    cta: {
      text: 'Fewer Than 29 Characters Max',
      href: '#',
      'data-pa-click': 'cta|CTA Text',
      target: '_self'
    },
    mediaButton: {
      id: '',
      text: 'This is Media Button',
      'data-video-id': 'rquuf4XfwLA',
      fpti: ''
    },
    hatchText: {
      text: 'Fewer than 34 characters per line'
    }
  },
  className: 'theme-new-money',
  children: _react2.default.createElement('div', null),
  callback: function callback() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/toggle-pullout/props/default.js
// module id = 1152
// module chunks = 4